import { createBrowserRouter } from "react-router-dom";

import Changelog from "../screens/Changelog";
import Feed from "../screens/Feed";
import Home from "../screens/Home";
import LastWeek from "../screens/LastWeek";
import Layout from "../layout/Layout";
import Leaderboards from "../screens/Leaderboards";
import MarchEvent from "../screens/MarchEvent";
import RaceModifiers from "../screens/RaceModifiers";
import Races from "../screens/Races";
import Subclasses from "../screens/Subclasses";
import Test from "../screens/Test";
import { Player } from "../screens/Player";
import { EpicsCalendar } from "../screens/EpicsCalendar";
import { EpicsDashboard } from "../screens/EpicsDashboard";
import { EpicLeaderboard } from "../screens/EpicLeaderboard";
import LeaderboardV2 from "../screens/LeaderboardsV2";
import Market from "../screens/Market";
import MarketItemStats from "../screens/MarketItemStats";
import Doubles from "../screens/Doubles";
import FernLog from "../screens/FernLog";
import FernUsage from "../screens/FernUsage";
import Gquests from "../screens/Gquests";
import GquestMobs from "../screens/GquestMobs";
// import Boards from "../screens/Boards";
import { Container } from "react-bootstrap";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home />, handle: { title: "Home" } },
      { path: "/leaderboards", element: <Leaderboards />, handle: { title: "Leaderboards" } },
      { path: "/leaderboards/players", element: <LeaderboardV2 />, handle: { title: "Player Leaderboards" } },
      { path: "/last", element: <LastWeek />, handle: { title: "Last Week" } },
      { path: "/feed", element: <Feed />, handle: { title: "Feed" } },
      { path: "/changelog", element: <Changelog />, handle: { title: "Changelog" } },
      { path: "/player", element: <Player />, handle: { title: "Player" } },
      { path: "/light-birthday", element: <MarchEvent />, handle: { title: "Light Birthday" } },
      { path: "/epics", element: <EpicsCalendar />, handle: { title: "Epics Calendar" } },
      { path: "/epics-dashboard", element: <EpicsDashboard />, handle: { title: "Epics Dashboard" } },
      { path: "/epic-leaderboard", element: <EpicLeaderboard />, handle: { title: "Epic Leaderboard" } },
      { path: "/gquests", element: <Gquests />, handle: { title: "Global Quests" } },
      { path: "/gquest-mobs", element: <GquestMobs />, handle: { title: "GQ Mob Guide" } },
      { path: "/subclasses", element: <Subclasses />, handle: { title: "Subclasses" } },
      { path: "/races", element: <Races />, handle: { title: "Races" } },
      { path: "/race-modifiers", element: <RaceModifiers />, handle: { title: "Race Modifiers" } },
      { path: "/market", element: <Market />, handle: { title: "Market" } },
      { path: "/market/item", element: <MarketItemStats />, handle: { title: "Item Price History" } },
      { path: "/doubles", element: <Doubles />, handle: { title: "Doubles" } },
      // Unlinked on purpose: not in Header nav
      { path: "/fern-log", element: <FernLog />, handle: { title: "Fern Log" } },
      { path: "/fern-usage", element: <FernUsage />, handle: { title: "Fern Usage" } },
      {
        path: "/boards",
        element: (
          <Container>
            <div className="my-4 text-center text-white">
              Boards are temporarily disabled to address an issue.
            </div>
          </Container>
        )
      },
      // {
      //   path: "/boards",
      //   element: <Boards />,
      //   children: [
      //     { index: true, element: <Boards /> },
      //     { path: ":boardName", element: <Boards /> },
      //     { path: ":boardName/:threadId", element: <Boards /> }
      //   ]
      // },
      { path: "/test", element: <Test /> }
      //   {
      //     path: "/courses",
      //     element: <Courses />,
      //     children: [
      //       { index: true, element: <CoursesIndex /> },
      //       { path: "/courses/:id", element: <Course /> },
      //     ],
      //   },
      //   { path: "*", element: <NoMatch /> },
    ]
  }
]);
